module.exports = __webpack_public_path__ + "static/media/KegstarLogo_Whole.62b89de0.svg";